import { IStrategy } from "../../models/IStrategy";

export class StrategyState {
  strategiesist: IStrategy[] = [];
}
